import { render, staticRenderFns } from "./UserLicensesForm.vue?vue&type=template&id=21f75ac0&scoped=true"
import script from "./UserLicensesForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLicensesForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f75ac0",
  null
  
)

export default component.exports